export default {"src":"/_next/static/media/1dentalCare.60205d66.svg","height":42,"width":36,"blurWidth":0,"blurHeight":0};